import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LoaderService, Message, RestService } from '@stdoutsrl/design-kit';

@Component({
  templateUrl: './report.component.html',
  styles: [],
  standalone: false
})
export class ReportComponent implements OnInit {

  constructor(private rest: RestService, private message: Message, private loader: LoaderService) { }

  date: any
  showTable = false
  stores: any = []
  selectedStore: any = {}
  employees: any[] = []
  selectedEmployee: any = {}
  calendarStart :any
  calendarEnd :any
  timeSheet :any[]= []
  totalHours = 0

  ngOnInit(): void {
    this.getStores()
    this.getEmployees()
  }

  selectMonth(event: any) {
    this.date = new Date(event.target.value)
    this.getMonthBounds(new Date(event.target.value))
    this.checkGetReport()
  }

  changeSelect(event: any, name: string) {
    let myThis: any = this
    myThis[name] = event
    this.checkGetReport()
  }

  getMonthBounds(date:Date) {
  const currentDate = new Date(date);
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    this.calendarStart = firstDay.toISOString()
    this.calendarEnd = lastDay.toISOString()
}

  getStores() {
    this.loader.on()
    this.rest.get('/store?options={%22page%22:1,%22filters%22:[]}').subscribe({
      next: (value: any) => {
        this.stores = value.data
        this.loader.off(true)
      },
    })
  }

  getEmployees() {
    this.loader.on()
    this.rest.get('/employee?options={%22page%22:1,%22filters%22:[]}').subscribe({
      next: (value: any) => {
        this.employees = value.data.map((res: any) => {
          res.completeName = res.firstName + ' ' + res.lastName
          return res
        })
        this.loader.off(true)
      },
    })
  }

  checkGetReport() {
    if (this.selectedEmployee.id && this.selectedStore.id && this.calendarStart && new Date(this.calendarStart).toISOString() && this.calendarEnd &&new Date(this.calendarEnd).toISOString()) {
      this.getEmployeeReport()
    }
  }

  getEmployeeReport() {
    this.loader.on()
    this.rest.get(`/shift/range?storeId=${this.selectedStore.id}&startDate=${this.calendarStart}&endDate=${this.calendarEnd}${this.selectedEmployee.id ? '&employeeId=' + this.selectedEmployee.id : ''}`).subscribe({
      next: (value:any) => {
        this.timeSheet = value.map((res:any)=>{
          res.day = new Date(res.date).getDate()
          return res
        })
        this.getTotalHours()
        this.showTable = true
       this.loader.off(true)
      },
      error: () => {
        this.loader.off(true)
      },
    })
  }

  getTotalHours(){
    let count = 0
    this.timeSheet.forEach((event:any) => {
      let h = parseInt(event.endTime.split(':')[0]) - parseInt(event.startTime.split(':')[0])
      let m = (parseInt(event.endTime.split(':')[1])/60) - (parseInt(event.startTime.split(':')[1])/60)
      count = count + h + m
    });
    this.totalHours = count
  }
}
